export type LabelKind = "29x90" | "62";
export type RasterSize = 256 | 512;

export type LabelSpec = {
  title: string;
  canvasW: number;
  canvasH: number;
  rasterSize: RasterSize;
  multi: boolean;
};

export const LABEL_SPECS: Record<LabelKind, LabelSpec> = {
  "29x90": {
    title: "DK-1201 · 29×90 die-cut",
    canvasW: 991,
    canvasH: 306,
    rasterSize: 256,
    multi: true,
  },
  "62": {
    title: "DK-2205 · 62 continuous",
    canvasW: 696,
    canvasH: 600,
    rasterSize: 512,
    multi: false,
  },
};

export function rasterUrl(hex: string, size: RasterSize): string {
  return `/raster/${size}/${hex.toLowerCase()}.png`;
}

export async function listRasters(size: RasterSize): Promise<string[]> {
  const res = await fetch(`/api/raster?size=${size}`);
  return await res.json();
}

export async function printStickers(
  label: LabelKind,
  hex: string[],
  count: number,
  endpoint = "/api/print",
): Promise<void> {
  const res = await fetch(endpoint, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ label, hex, count }),
  });
  if (!res.ok) throw new Error(await res.text());
}
